import { config, XMLY, XMplayer } from '@xmly-fem/web-jssdk'
// 小封 711b95c684f1b6d763e0a933034114e1
export const getAudioAccess = () => {
    config({
        app_key: '711b95c684f1b6d763e0a933034114e1', // 必传，官方提供的 app_key：b617866c20482d133d5de66fceb37da3 仅供测试，有调用次数限制，上线需替换为自己的 app_key。
        device_id: XMLY.getDeviceId(),
        // 官方提供测试使用的 sig_url => https://api.ximalaya.com/openapi-collector-app/jssdk_sig
        // （限制了 app_key 必须是测试账号，并且限制了调用次数，上线需替换为自己的 sig_url）
        // sig_url: 'https://api.ximalaya.com/openapi-collector-app/jssdk_sig', // 免登录授权，必须传 sig_url，和 get_access_token 互斥
        sig_url: process.env.NODE_ENV === 'development' ? 'https://yun.thecover.cn/chat-bot-dev/audio/sign':'https://yun.thecover.cn/chat-bot/audio/sign',
        debug: true, // 是否在控制台打印日志
    })
}
